import React from 'react';
import { Star } from 'lucide-react';
interface Testimonial {
  name: string;
  age: number;
  city: string;
  quote: string;
}
export function Testimonials() {
  const testimonials: Testimonial[] = [{
    name: 'Martín G.',
    age: 38,
    city: 'Rosario',
    quote: 'Increíble cómo mejoró mi juego en solo 3 semanas. Las tácticas de pareja son oro puro.'
  }, {
    name: 'Lucas P.',
    age: 42,
    city: 'Córdoba',
    quote: 'Finalmente entendí cómo usar mi derecha como ventaja. Los diagramas son clarísimos.'
  }, {
    name: 'Sofía R.',
    age: 34,
    city: 'Mar del Plata',
    quote: 'El plan de 90 días es perfecto. Pasé de 4ta a 3ra categoría siguiendo el método.'
  }, {
    name: 'Diego F.',
    age: 45,
    city: 'Buenos Aires',
    quote: 'Los ejercicios de pista son exactamente lo que necesitaba. Muy bien explicados.'
  }, {
    name: 'Pablo M.',
    age: 29,
    city: 'Mendoza',
    quote: 'El análisis de rivales me cambió la forma de jugar. Ahora leo el partido diferente.'
  }];
  return <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-141">
      <div className="max-w-6xl mx-auto" data-id="element-142">
        <h2 className="headline-font text-4xl md:text-5xl text-center text-white uppercase mb-4" data-id="element-143">
          Lo Que Dicen Nuestros{' '}
          <span className="text-[#C6FF3C]" data-id="element-144">Jugadores</span>
        </h2>
        <p className="text-center text-gray-400 text-lg mb-12" data-id="element-145">
          Más de 1.500 jugadores ya mejoraron su juego
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-146">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-gray-900 border border-gray-800 rounded-lg p-6" data-id="element-147">
              <div className="flex gap-1 mb-4" data-id="element-148">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-[#C6FF3C] text-[#C6FF3C]" data-id="element-149" />)}
              </div>
              <p className="text-gray-300 mb-4 italic" data-id="element-150">"{testimonial.quote}"</p>
              <div className="border-t border-gray-800 pt-4" data-id="element-151">
                <p className="font-bold text-white" data-id="element-152">{testimonial.name}</p>
                <p className="text-sm text-gray-400" data-id="element-153">
                  {testimonial.age} años — {testimonial.city}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}